import { tw } from "@noones/ui/tw";
import React from "react";
import { StatusCardsList } from "./Health/StatusCardsList";
import { PastIncidents } from "./PastIncidents/PastIncidents";
import { UnresolvedIncidentCards } from "./UnresolvedIncidents/UnresolvedIncidents";

export const Status = () => {
    return (
        <div className={tw.w_full.flex.flex_col.gap_6}>
            <UnresolvedIncidentCards />

            <StatusCardsList />

            <PastIncidents />
        </div>
    );
};
